import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../notifications";
import { setOverflowMenuVisible } from "../toolbox/actions.web";
import { disableLiveCaption, disableSaveLiveCaption, enableLiveCaption, enableSaveLiveCaption } from "./slice";
export const getState = (state) => state['features/live-caption'];
export const getEnabledSaveCaption = (state) => getState(state)?.enabledSaveCaption;
export const getEnabled = (state) => getState(state)?.enabled;
export const getStreamStatus = (state) => getState(state)?.streamStatus;
export const getCaptions = (state) => getState(state)?.captions;
export const getVisibleCaptions = (state) => getState(state)?.visibleCaptions;
export const saveCaption = (isOn) => (dispatch) => {
    if (isOn) {
        dispatch(enableSaveLiveCaption());
    }
    else {
        dispatch(disableSaveLiveCaption());
    }
    dispatch(setOverflowMenuVisible(false));
};
export const onCaption = (isOn) => (dispatch) => {
    dispatch(showNotification({
        titleKey: isOn ? 'notify.startLiveCaption' : 'notify.stopLiveCaption'
    }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
    if (isOn) {
        dispatch(enableLiveCaption());
    }
    else {
        dispatch(disableLiveCaption());
    }
    // dispatch(setOverflowMenuVisible(false));
};
